import React from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { apiFetch } from "@/lib/api";
import { timeAgo } from "@/lib/format";
import { PageLoader, EmptyState } from "@/components/common";
import { UserX, Check, X } from "lucide-react";

export function AdminDeletions() {
  const qc = useQueryClient();
  const { data: reqs, isLoading } = useQuery({ queryKey: ["admin-deletions"], queryFn: () => apiFetch("/admin/deletion-requests") });

  const decide = async (id, approve) => {
    if (approve && !window.confirm("Approve deletion? This closes the account and hides all listings.")) return;
    try {
      await apiFetch(`/admin/deletion-requests/${id}/decision`, { method: "POST", body: JSON.stringify({ approve }) });
      toast.success(approve ? "Account deleted" : "Request declined");
      qc.invalidateQueries({ queryKey: ["admin-deletions"] });
    } catch (err) { toast.error(err.message); }
  };

  if (isLoading) return <PageLoader />;

  return (
    <div className="space-y-2">
      {reqs.length === 0 ? <EmptyState icon={UserX} title="No deletion requests" /> : reqs.map((r) => (
        <div key={r.id} className="flex items-center gap-3 rounded-2xl border border-border p-3" data-testid={`deletion-${r.id}`}>
          <div className="min-w-0 flex-1">
            <p className="truncate font-semibold">{r.user_name || r.user_email || r.user_id}</p>
            <p className="text-sm text-muted-foreground">{r.reason || "No reason given"}</p>
            <p className="text-xs text-muted-foreground">{timeAgo(r.created_at)}</p>
          </div>
          <button onClick={() => decide(r.id, true)} className="flex items-center gap-1 rounded-lg bg-destructive px-3 py-1.5 text-xs font-semibold text-white" data-testid={`approve-deletion-${r.id}`}><Check className="h-3.5 w-3.5" />Approve</button>
          <button onClick={() => decide(r.id, false)} className="flex items-center gap-1 rounded-lg bg-secondary px-3 py-1.5 text-xs font-semibold" data-testid={`decline-deletion-${r.id}`}><X className="h-3.5 w-3.5" />Decline</button>
        </div>
      ))}
    </div>
  );
}
